import { render } from "./watch_teacher.vue?vue&type=template&id=77442eba"
import script from "./watch_teacher.vue?vue&type=script&lang=js"
export * from "./watch_teacher.vue?vue&type=script&lang=js"

import "./watch_teacher.vue?vue&type=style&index=0&id=77442eba&lang=css"

import exportComponent from "D:\\web\\userBehavior-course\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__